// Action types for fetching orders
export const FETCH_ORDERS_COUNT_REQUEST = 'FETCH_ORDERS_COUNT_REQUEST';
export const FETCH_ORDERS_COUNT_SUCCESS = 'FETCH_ORDERS_COUNT_SUCCESS';
export const FETCH_ORDERS_COUNT_FAILURE = 'FETCH_ORDERS_COUNT_FAILURE';
export const FETCH_ORDERS_COUNT_REST = 'FETCH_ORDERS_COUNT_REST';
// Fetch data actions
export const fetchOrdersCountRequest = (payload) => ({
    type: FETCH_ORDERS_COUNT_REQUEST,
    payload,
});
export const fetchOrdersCountSuccess = (payload) => ({
    type: FETCH_ORDERS_COUNT_SUCCESS,
    payload,
});
export const fetchOrdersCountFailure = (error) => ({
    type: FETCH_ORDERS_COUNT_FAILURE,
    payload: error,
});
export const fetchOrdersCountRest = () => ({
    type: FETCH_ORDERS_COUNT_REST,
});
